import Vue from 'vue'
import App from './app.vue'
import store from './store'

//css
import 'iview/dist/styles/iview.css'
import './assets/css/careHome.scss'
import '../../assets/css/fix.scss'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
//js
import calendar from './assets/js/calendar.js'
Object.defineProperty(Vue.prototype, '$calendar', {
	value: calendar
});
// new Vue({
// 	store,
// 	el: (typeof agho == 'object' && agho.el) || '#app',
// 	render: h => h(App)
// })

import Nav from '@/component/Nav.vue'
if (typeof agho == 'object' && agho.el) {
	new Vue({
		store,
		el: (typeof agho == 'object' && agho.el) || '#app',
		render: h => h(App)
	})
} else {
	Vue.component('app', App)
	new Vue({
		store,
		el: '#app',
		render: h => h(Nav)
	})
}